import { render, staticRenderFns } from "./EventDetailsView.vue?vue&type=template&id=23c4fc3c&"
import script from "./EventDetailsView.vue?vue&type=script&lang=js&"
export * from "./EventDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports